import { render, staticRenderFns } from "./MemberBox.vue?vue&type=template&id=0db9cb52&scoped=true"
import script from "./MemberBox.vue?vue&type=script&lang=js"
export * from "./MemberBox.vue?vue&type=script&lang=js"
import style0 from "./MemberBox.vue?vue&type=style&index=0&id=0db9cb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9cb52",
  null
  
)

export default component.exports